import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setClaimDetails = claim =>
  call(websocketFetch, 'set_claim_details', claim);
